/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { FC } from 'react'
import { Menu, Dropdown, Layout, Badge, Row, Col, Button } from 'antd'
import { BtnAnch, globalConfirm } from 'components/elements/global'
import useAuth from 'hooks/useAuth'
import useCheckModule from 'hooks/useCheckModule'
import { AvatarStatus } from 'components/elements/AvatarStatus'
import { useGlobal } from 'raducer/global'
import { ADMIN_PREFIX_PATH, APP_PREFIX_PATH } from 'config'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import {
 MyBrokerageIcon,
 SvgCalenderIcon,
 SvgInbox,
 SvgNotificationICon,
} from 'components/icons'
import { useLogoutMutation } from 'features/auth'
import style from './Navbar.module.scss'

const Navbar: FC<{
 collapsed: boolean
 setCookie: (name: 'ar_sidebar', value: string, options?: any) => void
}> = ({ collapsed, setCookie }) => {
 const { toggleNotification, global } = useGlobal()
 const { user } = useAuth()
 const { checkIsModule } = useCheckModule()
 const [logout] = useLogoutMutation()
 const navigate = useNavigate()
 const { pathname } = useLocation()

 const handlelogout = (): void => {
  globalConfirm({
   content: 'Are you sure you want to logout?',
   onOk: async () => {
    await logout().unwrap()
    localStorage.removeItem('user-onboard-local')
   },
  })
 }

 const getItem = (
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  onClick?: () => void,
  type?: 'group',
 ) => ({ key, label, icon, type, onClick })

 const items = [
  getItem('Profile', 'profile', <i className="fas fa-user" />, () =>
   navigate(`${ADMIN_PREFIX_PATH}/profile`),
  ),
  getItem(
   'Getting Started',
   'go-to-landing-page',
   <i className="fas fa-sliders-h" />,
   () => navigate(`${ADMIN_PREFIX_PATH}/user-onboard`),
  ),
  getItem('Signature', 'signature', <i className="fas fa-signature" />, () =>
   navigate(`${ADMIN_PREFIX_PATH}/settings/signature`),
  ),
  getItem('Reset Password', 'reset-pass', <i className="fas fa-key" />, () =>
   navigate(`${ADMIN_PREFIX_PATH}/settings/reset-password`),
  ),
  // My Brokerage / My Realtors only when the `my_brokerage` module is enabled
  ...(checkIsModule('my_brokerage')
   ? [
      user?.account_type === 'Realtor'
       ? getItem(
          'My Brokerage',
          'my-brokerage',
          <div className={style.brokerageIcon}>
           <MyBrokerageIcon />
          </div>,
          () => navigate(`${APP_PREFIX_PATH}/my-brokerage`),
         )
       : getItem(
          'My Realtors',
          'realtors',
          <i className="fas fa-users" />,
          () => navigate(`${APP_PREFIX_PATH}/realtors`),
         ),
     ]
   : []),
  getItem('Logout', 'logout', <i className=" fas fa-sign-out-alt" />, () =>
   handlelogout(),
  ),
 ]

 return (
  <Layout.Header
   className="base-navbar"
   style={{
    background: 'unset',
    left: collapsed ? '80px' : '200px',
    paddingLeft: '10px',
    transition: 'left 0.2s',
   }}
  >
   <Row align="middle" className="w-100" justify="space-between">
    <Col>
     <ul className="nav-links-header">
      <Button
       type="text"
       icon={
        collapsed ? (
         <i className="fas fa-arrow-right" />
        ) : (
         <i className="fas fa-bars" />
        )
       }
       onClick={() => {
        if (collapsed) {
         setCookie('ar_sidebar', '0', { path: '/', maxAge: 31536000 })
        } else {
         setCookie('ar_sidebar', '1', { path: '/', maxAge: 31536000 })
        }
       }}
       style={{
        fontSize: '16px',
        width: 64,
        height: 64,
       }}
      />
      <li className={style.inboxcalander}>
       <NavLink
        className={
         pathname?.includes(`${ADMIN_PREFIX_PATH}/inbox/`) ? 'active' : ''
        }
        to={`${ADMIN_PREFIX_PATH}/inbox/email/inbox`}
       >
        <SvgInbox /> Inbox
       </NavLink>
      </li>
      <li className={style.inboxcalander}>
       <NavLink to={`${ADMIN_PREFIX_PATH}/calendar`}>
        <SvgCalenderIcon /> Calendar
       </NavLink>
      </li>
     </ul>
    </Col>
    <Col>
     <ul className="nav-links-header">
      <li>
       <Badge overflowCount={99999} offset={[-6, -5]} count={global.unreadnoti}>
        <BtnAnch
         onClick={() => toggleNotification()}
         tooltipText="Notification"
         className={style.notification}
        >
         <SvgNotificationICon />
        </BtnAnch>
       </Badge>
      </li>
      <li>
       <Dropdown arrow placement="bottomRight" overlay={<Menu items={items} />}>
        <a onClick={(e) => e.preventDefault()}>
         <AvatarStatus
          avatar={{ size: 30 }}
          theme="light"
          title={user?.name ?? ''}
          titleClassName="w-100"
          subTitle={user?.account_type ?? ''}
         />
         <i className="far fa-angle-down ms-2" />
        </a>
       </Dropdown>
      </li>
     </ul>
    </Col>
   </Row>
  </Layout.Header>
 )
}

export default Navbar
